<template>
  <div class="home">
    <div id="slideshow" class="aspect-fix w19h10">
      <div class="container" v-if="active">
        <div :class="{slide:true, active:currentSlide == index}" v-for="(post, index) in data['acf']['slideshow']" :key="post.id">
          <router-link :to="{ name : 'WorkDetail', params : { name: post.slug }}">
          <img 
            :data-src="index !=-1 ? post['featured_image'].src : null" 
            :data-srcset="post['featured_image'].srcset"
            :alt="post['post_title']"
            class="lazyload lazy-fade"
            @load="slideLoaded">
          </router-link>
        </div>
      </div>
    </div>
    <article class="article page" v-if="active">
      <main v-html="data.content.rendered"></main>
    </article>
  </div>
</template>

<style lang="scss" scoped>


#slideshow{

  min-height: 280px;

  .slide{
    position: absolute;
    width:100%;
    height:100%;
    top:0;
    left:0;
    opacity:0;
    transition: 1s;
    z-index: 1;
    pointer-events: none;
  

    &.active{
      opacity: 1;
      z-index: 2;
      pointer-events: auto;
    }

    img{
      width:100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
</style>

<script>
// import { mapState } from 'vuex'

import PageData from '@/mixins/PageData'

export default {
  mixins:[PageData],

  data:()=>({
    data: null,
    active: false,
    slidePlaying: false,
    slideLength:0,
    currentSlide:0,
  }),

  watch:{
    // infoLoaded(){

    //   this.$nextTick(() => {
    //     if(this.infoLoaded && !this.slidePlaying) this.beginSlide()
    //   })
    // }
  },

  created(){
    
  },

  mounted(){

    this.pageLoading()

    this.getPage('home')
    .then(data =>{
        this.data = data;
        this.active = true;
        this.pageLoaded()
        this.beginSlide()
    })
    this.$nextTick(function () {
      if(this.active && !this.slidePlaying) this.beginSlide()
    })
    
  },

  methods:{

    beginSlide(){
      this.slideLength = this.data['acf']['slideshow'].length
      this.currentSlide = 0
      setInterval(this.nextSlide,5000)
    },
    nextSlide(){
      // console.log("next")
      this.currentSlide ++;
      if(this.currentSlide == this.slideLength) this.currentSlide = 0;
    },
    slideLoaded(/*event*/){
      // console.log(event.target)
    }
  }
}
</script>
